const values = [
  {
    icon: 'ri-focus-3-line',
    title: 'iOS-First Philosophy',
    desc: 'We build exclusively for the iOS platform, allowing us to master every nuance of Apple\'s ecosystem and deliver truly native experiences.',
  },
  {
    icon: 'ri-heart-pulse-line',
    title: 'User-Centered Design',
    desc: 'Every decision — from architecture to interface — is made with the end user in mind. Simplicity and clarity are never compromised.',
  },
  {
    icon: 'ri-lock-2-line',
    title: 'Security by Default',
    desc: 'Security is not an afterthought. It is embedded into every layer of our products, ensuring users are always protected.',
  },
];

export default function AboutSection() {
  return (
    <section id="about" className="py-28 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col lg:flex-row gap-16 items-center">
          {/* Left content */}
          <div className="flex-1">
            <p className="text-xs uppercase tracking-[0.3em] text-gray-400 mb-4 font-medium">About Us</p>
            <h2 className="text-4xl md:text-5xl font-light text-gray-900 leading-tight mb-6">
              About <span className="font-semibold">PRIMA d.o.o.</span>
            </h2>
            <p className="text-gray-500 text-base leading-relaxed mb-4">
              PRIMA d.o.o. is a dedicated iOS application development company based in Kozarac, Bosnia and Herzegovina. Our team of passionate engineers and designers focuses exclusively on the Apple ecosystem, building products that are both powerful and beautifully simple.
            </p>
            <p className="text-gray-500 text-base leading-relaxed mb-10">
              Founded with a mission to make mobile security and device optimization accessible to everyone, we have grown into a trusted name in the iOS app space. Our products serve users across the globe, delivering reliable performance and uncompromising privacy.
            </p>

            {/* Values */}
            <div className="flex flex-col gap-5">
              {values.map((v) => (
                <div key={v.title} className="flex items-start gap-4">
                  <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-gray-100 flex-shrink-0 mt-0.5">
                    <i className={`${v.icon} text-base text-gray-600`} />
                  </div>
                  <div>
                    <h4 className="text-sm font-semibold text-gray-900 mb-1">{v.title}</h4>
                    <p className="text-sm text-gray-500 leading-relaxed">{v.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right decorative */}
          <div className="flex-1 relative flex justify-center items-center min-h-[480px]">
            <div className="relative w-full max-w-md">
              <img
                src="https://public.readdy.ai/ai/img_res/2589c8b177417e9776b0ca496a8b55e4.jpg"
                alt="PRIMA d.o.o. team"
                className="w-full h-80 object-cover object-top rounded-3xl"
              />
              {/* Floating card */}
              <div className="absolute -bottom-6 -left-6 bg-white border border-gray-100 rounded-2xl px-5 py-4 w-48">
                <div className="flex items-center gap-2 mb-1">
                  <div className="w-2 h-2 rounded-full bg-emerald-400" />
                  <span className="text-xs font-medium text-gray-700">iOS Specialists</span>
                </div>
                <p className="text-xs text-gray-400">Kozarac, Bosnia &amp; Herzegovina</p>
              </div>
              {/* Decorative blobs */}
              <div className="absolute -top-8 -right-8 w-40 h-40 rounded-full bg-gradient-to-br from-gray-100 to-gray-50 -z-10" />
              <div className="absolute -bottom-12 right-8 w-24 h-24 rounded-full bg-gradient-to-br from-gray-100 to-gray-50 -z-10" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
